import clsx from 'clsx';
import React from 'react';

import imgNTRS from 'images/pro/NTRS.png';
import imgNYTLogo from 'images/pro/New-York-Times-logo.png';
import imgAtBayLogo from 'images/pro/at-bay-logo.png';
import imgEdbLogo from 'images/pro/edb-logo.png';

import { CORPORATE_SUBSCRIPTION_FORM_URL, PARTNERSHIP_FORM_URL } from '@utils/constants';

const ProOpportunities = () => (
  <div className="px-16 py-48 xs:px-48 md:py-64">
    <div className="mx-auto max-w-[650px] rounded-10 px-16 py-24 shadow-pro md:max-w-[1024px] md:p-48">
      <div className="relative justify-center md:flex">
        <div
          className={clsx(
            'mx-auto flex flex-col justify-center border-0 border-solid border-stone-300',
            'md:order-1 md:mx-0 md:max-w-[575px] md:border-l md:pl-48'
          )}
        >
          <p className="m-0 font-sans text-overline uppercase text-primary-red">New</p>
          <h3 className="m-0 mt-16 font-serif text-headline-sm text-primary-black md:text-headline-lg">
            Brand Partnerships
          </h3>
          <p className="m-0 mt-16 font-serif text-paragraph text-black">
            The Information has a highly engaged and influential subscriber base of startup
            founders, venture capitalists, and technology decision makers. We offer numerous
            opportunities for brands to share their message with our subscribers.
          </p>
          <div className="absolute bottom-0 flex w-full flex-col gap-x-12 gap-y-24 md:static md:mt-16 md:flex-row">
            <a
              href={`${PARTNERSHIP_FORM_URL}?source=pro_landing_page`}
              className={clsx(
                'bg-primary-red font-sans text-button-md uppercase !text-white',
                'flex h-40 items-center justify-center rounded-r-2 md:w-[245px]',
                'transition-colors hover:bg-pro-red focus:bg-pro-red'
              )}
            >
              Learn More
            </a>
          </div>
        </div>
        <div className="mx-auto mt-16 flex w-full shrink-0 items-center justify-center gap-x-48 gap-y-80 pb-[136px] md:m-0 md:w-[248px] md:flex-col md:py-36 md:pr-48">
          <div className="h-[30px] w-80 md:h-[60px] md:w-[150px]">
            <img
              className="block h-full w-full object-contain object-center"
              src={imgEdbLogo}
              alt="EDB Singapore"
            />
          </div>
          <div className="h-[30px] w-80 md:h-[60px] md:w-[150px]">
            <img
              className="block h-full w-full object-contain object-center"
              src={imgAtBayLogo}
              alt="At Bay"
            />
          </div>
          <div className="h-[30px] w-80 md:h-[60px] md:w-[150px]">
            <img
              className="block h-full w-full object-contain object-center"
              src={imgNTRS}
              alt="Northern Trust"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="mx-auto mt-32 max-w-[650px] rounded-10 px-16 py-24 shadow-pro md:mt-48 md:max-w-[1024px] md:p-48">
      <div className="relative justify-center md:flex">
        <div
          className={clsx(
            'mx-auto flex flex-col justify-center border-0 border-b border-solid border-stone-300 pb-16',
            'md:order-1 md:mx-0 md:max-w-[575px] md:border-b-0 md:border-l md:pb-0 md:pl-48'
          )}
        >
          <p className="m-0 font-sans text-overline uppercase text-primary-red">
            More opportunities
          </p>
          <h3 className="m-0 mt-16 font-serif text-headline-sm text-primary-black md:text-headline-lg">
            Corporate Subscriptions
          </h3>
          <p className="m-0 mt-16 font-serif text-paragraph text-black">
            Empower your team with deep industry knowledge and networking opportunities with other
            subscribers. The Information corporate subscription packages are available for teams of
            all sizes.
          </p>
          <a
            href={`${CORPORATE_SUBSCRIPTION_FORM_URL}?source=pro_landing_page`}
            className={clsx(
              'absolute bottom-0 bg-primary-red font-sans text-button-md uppercase !text-white md:static',
              'flex h-40 w-full items-center justify-center rounded-r-2 md:mt-16 md:w-[245px]',
              'transition-colors hover:bg-pro-red focus:bg-pro-red'
            )}
          >
            Learn More
          </a>
        </div>
        <div className="mx-auto flex w-full shrink-0 flex-col justify-center pb-72 md:m-0 md:w-[248px] md:py-36 md:pr-48">
          <p className="m-0 ml-24 mt-16 font-sans text-paragraph text-primary-black md:mx-0">
            <span className="absolute left-0 translate-y-[10px] font-sans text-[42px] font-medium text-pro-red md:left-auto md:-translate-y-[16px] md:text-[72px]">
              “
            </span>
            The Information{'’'}s reporters have become{' '}
            <span className="font-sans font-bold">
              known in Silicon Valley for sniffing out the industry{'’'}s misdeeds and tweaking its
              powerful.”
            </span>
          </p>
          <div className="ml-24 mt-16 w-[172px] md:mx-0 md:mt-32">
            <img
              className="block w-full object-contain"
              src={imgNYTLogo}
              alt="The New York Times"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProOpportunities;
